import {UserAuthorizationContextValue} from "./UserAuthorizationContextValue";
import {useContext} from "react";
import {UserAuthorizationContext} from "./UserAuthorizationContext";

export function useUserAuthorizations(): UserAuthorizationContextValue {
  return useContext(UserAuthorizationContext);
}
